import { Autorizacao } from "view/component/Autorizacao/Autorizacao";
import { BotaoTipo } from "../../view/component/Botao/Botao"

export interface Situacao {
  id: number,
  nome: string,
}


class SituacaoImpl implements Situacao {
  constructor(public readonly id: number, public readonly nome: string) {}
}

export class Situacoes {
  private constructor() {}

  public static readonly EM_ABERTO: Situacao = new SituacaoImpl(1, "Em Aberto")
  public static readonly EM_ANDAMENTO: Situacao = new SituacaoImpl(2, "Em Andamento")
  public static readonly AGUARDANDO_PARECER_SOLICITANTE: Situacao = new SituacaoImpl(3, "Aguardando Parecer do Solicitante")
  public static readonly CONCLUIDO: Situacao = new SituacaoImpl(4, 'Concluído')
  public static readonly FECHADO: Situacao = new SituacaoImpl(5, 'Fechado')
  public static readonly CANCELADO: Situacao = new SituacaoImpl(6, 'Cancelado')

  public static readonly NAO_DEFINIDA: Situacao = new SituacaoImpl(-1, 'Erro - Situação não definida')

  public static asArray() {
    return [
      this.EM_ABERTO,
      this.EM_ANDAMENTO,
      this.AGUARDANDO_PARECER_SOLICITANTE,
      this.CONCLUIDO,
      this.FECHADO,
      this.CANCELADO,
    ]
  }

  public static getAllOnListIdNivel1() {
    return [
      this.EM_ABERTO.id,
      this.EM_ANDAMENTO.id,
      this.AGUARDANDO_PARECER_SOLICITANTE.id,
      this.CONCLUIDO.id,
    ]
  }

  private static situacoesById = Object.fromEntries(Situacoes.asArray().map(x => [x.id, x]))

  public static byId(id?: number) {
    const situacao = Situacoes.situacoesById[id ?? -1]

    return situacao ?? Situacoes.NAO_DEFINIDA;
  }
}

/**
 * Ter certeza que a transição de fato deve ser realizada
 */
export class ConfirmarTransicaoSituacao {
  constructor(
    public readonly titulo: string,
    public readonly mensagem: string,
    public readonly nomeBotaoConfirmacao: string,
    public readonly nomeBotaoCancelar: string,
  ) {}

  static readonly CONFIRMAR_CANCELAMENTO = new ConfirmarTransicaoSituacao(
    "Cancelar solicitação?",
    "Você deseja realmente cancelar esta solicitação? Solicitações canceladas não podem ser reabertas!",
    "Sim, cancelar",
    "Não, fechar"
  )
}


export class TransicaoSituacaoComplexa {
  public constructor(
    public readonly descricao: string,
    public readonly destino: Situacao,
    public readonly tipo: BotaoTipo,
    public readonly confirmarTransicao?: ConfirmarTransicaoSituacao,
  ) {}
}


export class TransicaoSituacao {
  
  private readonly transicoes: Map<number, TransicaoSituacaoComplexa[]> = new Map()

  /**
   * Regra de negócio: Transição de Concluído para Fechado só irá através de avaliação
   */
  public constructor(public readonly autorizacao: Autorizacao) {
    if (autorizacao.papeis.Nivel1) {
      this.transicoes.set(Situacoes.EM_ABERTO.id,
          [
            new TransicaoSituacaoComplexa("Atender", Situacoes.EM_ANDAMENTO, 'default'), 
            new TransicaoSituacaoComplexa(
              "Cancelar", Situacoes.CANCELADO, 'warning',
              ConfirmarTransicaoSituacao.CONFIRMAR_CANCELAMENTO
            )
          ]
      )
      this.transicoes.set(Situacoes.EM_ANDAMENTO.id, 
          [
            new TransicaoSituacaoComplexa("Solicitar Parecer", Situacoes.AGUARDANDO_PARECER_SOLICITANTE, 'default'), 
            new TransicaoSituacaoComplexa("Concluir", Situacoes.CONCLUIDO, 'success'), 
            new TransicaoSituacaoComplexa(
              "Cancelar", Situacoes.CANCELADO, 'warning',
              ConfirmarTransicaoSituacao.CONFIRMAR_CANCELAMENTO
            )
          ]
      )
      this.transicoes.set(Situacoes.AGUARDANDO_PARECER_SOLICITANTE.id, 

          [
            new TransicaoSituacaoComplexa("Voltar a atender", Situacoes.EM_ANDAMENTO, 'default'),
            new TransicaoSituacaoComplexa(
              "Cancelar", Situacoes.CANCELADO, 'warning',
              ConfirmarTransicaoSituacao.CONFIRMAR_CANCELAMENTO
            )
          ]
      )
      this.transicoes.set(Situacoes.CANCELADO.id, 

        [
          new TransicaoSituacaoComplexa("Estornar cancelamento", Situacoes.EM_ABERTO, 'default')
        ]
    )
    } else {
      this.transicoes.set(Situacoes.EM_ABERTO.id,
        [
          new TransicaoSituacaoComplexa(
            "Cancelar", Situacoes.CANCELADO, 'warning',
            ConfirmarTransicaoSituacao.CONFIRMAR_CANCELAMENTO
          )
        ]
      )
    }
  }

  public by(situacao: Situacao): TransicaoSituacaoComplexa[] {
    return this.transicoes.get(situacao.id) ?? []
  }
}
